export const PATHS = {
  root: '/',
  main: '/main',
  login: '/login',
  oAuth: {
    google: '/_o/google',
    kakao: '/_o/kakao',
    naver: '/_o/naver',
  },
  badge: {
    index: '/badge',
    list: '/badge/list',
    setting: '/badge/setting',
  },
  point: {
    list: '/point/list',
  },
  vote: {
    list: '/vote/list',
    detail: '/vote/detail/:id',
  },
  user: {
    list: '/user/list',
    detail: '/user/detail/:id',
  },
  page403: '/403',
  page404: '/404',
  page500: '/500',
};
